import { useNavigation } from '@react-navigation/native'
import React, { useCallback } from 'react'
import { Pressable } from 'react-native'

import { Avatar } from 'widgets/Avatar'
import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Text } from 'widgets/Text'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useDMRoom } from 'hooks/useDMRoom'

import { links } from 'utils/constants'
import { createPartialUser } from 'utils/user/createPartialUser'

import { UserType } from 'types/user'

interface SearchResultRowProps {
  user: UserType
  onSelect?: () => void
}

export const SearchResultRow = ({ user, onSelect }: SearchResultRowProps) => {
  const { data: currentUser } = useCurrentUser()
  const navigation = useNavigation<any>()
  const { createRoom } = useDMRoom({})

  const createChatRoom = useCallback(
    async (tempUser: UserType) => {
      if (currentUser && tempUser) {
        const { id: roomId } = await createRoom.mutateAsync({
          participants: [createPartialUser(currentUser), createPartialUser(tempUser)],
        })

        navigation.navigate(links.CHAT_ROOM, { roomId })
        onSelect && onSelect()
      }
    },
    [currentUser, createRoom, navigation, onSelect],
  )

  return (
    <Pressable onPress={() => createChatRoom(user)}>
      <Box flexDirection='row'>
        <Box padding='md'>
          <Avatar width={64} height={64} image={user.avatar} />
        </Box>
        <Box
          flex={1}
          flexDirection='column'
          justifyContent='flex-start'
          margin={{ top: 'lg', right: 'lg' }}
        >
          <Box flexDirection='row' align='center'>
            <Box flex={1} margin={{ right: 'xs' }}>
              <Text fontWeight='semiBold' fontSize='sm' numberOfLines={1}>
                {`${user.firstName} ${user.lastName}`}
              </Text>
            </Box>
          </Box>

          <Text numberOfLines={2} color='greyDarkest' fontSize='sm'>
            {user?.isTrainer ? 'Coach' : 'Member'}
          </Text>
        </Box>
        <Box margin={{ top: 'lg', right: 'md' }}>
          <Icon size={24} name='chevron-right' color='greyDarkest' />
        </Box>
      </Box>
    </Pressable>
  )
}
